export default __webpack_public_path__ + "static/media/loader_bg_white.c22707d6.png";